export const prepareParams = ({
  status,
  pageNumber,
  pageSize,
  searchKeyword,
  startDate,
  endDate,
}) => {
  return {
    status: status === "all" || status === "archived" ? undefined : status,
    startDate: startDate?.format("YYYY-MM-DD 00:00:00"),
    endDate: endDate?.format("YYYY-MM-DD 23:59:00"),
    searchKeyword: searchKeyword ?? "",
    pageNumber: pageNumber,
    pageSize: pageSize,
    isArchived: status === "archived" ? true : false,
  };
};
